import React from 'react'
import { motion } from "framer-motion";
import { Send } from 'lucide-react';
const EventCTA = () => {
    return (
        <section className="relative w-full overflow-hidden  lg:py-24 md:py-16 py-10 text-slate-900">
            <div className="relative z-10 mx-auto flex flex-col items-center px-6 lg:px-12 3xl:w-4/5 xl:w-[90%]">
                <div className="mb-16 flex max-w-4xl flex-col items-center text-center md:mb-20">
                    <motion.h2
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.08 }}
                        className="font-display text-3xl sm:text-4xl md:text-5xl font-bold px-6 lg:px-0 tracking-tight text-slate-950 "
                    >
                        Get answers to your
                        {" "}
                        <span className="italic font-serif font-normal text-[#5dc9f0]">
                            questions
                        </span>{" "}
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 15 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.15 }}
                        className="mt-5 max-w-2xl text-base font-normal leading-relaxed px-6 lg:px-0 text-slate-600 sm:text-lg"
                    >
                        Our clients turn to us to help them reimagine ways of working with technology.
                    </motion.p>
                </div>
                <div className="rounded-3xl md:w-4/5  bg-white border border-slate-200/90 p-6 sm:p-8 shadow-sm relative overflow-hidden">
                    <div className="relative z-10 space-y-6 w-full">
                        <form
                            onSubmit={(e) => e.preventDefault()}
                            className="space-y-4"
                        >
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="space-y-1.5">
                                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                        First Name *
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        placeholder="John"
                                        className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all"
                                    />
                                </div>
                                <div className="space-y-1.5">
                                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                        Business Email *
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        placeholder="j.doe@enterprise.com"
                                        className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="space-y-1.5">
                                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                        Organization *
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        placeholder="j.doe@enterprise.com"
                                        className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all"
                                    />
                                </div>
                                <div className="space-y-1.5">
                                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                        Phone Number
                                    </label>
                                    <input
                                        type="tel"
                                        placeholder="+91 00000-00000"
                                        className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all"
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="space-y-1.5">
                                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                        Country *
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        placeholder="Acme Financial Corp"
                                        className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all"
                                    />
                                </div>
                                <div className="space-y-1.5">
                                    <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                        Industry Type *
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        placeholder="Acme Financial Corp"
                                        className="w-full px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all"
                                    />
                                </div>
                            </div>
                            <div className="space-y-1.5">
                                <label className="text-xs font-bold uppercase tracking-wider text-slate-600">
                                    Message *
                                </label>
                                <textarea
                                    rows={4}
                                    required
                                    placeholder="Outline target workflows, legacy platform (e.g. Pega, IBM BPM), and timeline..."
                                    className="w-full p-4 rounded-xl bg-slate-50 border border-slate-200 text-slate-900 text-sm focus:bg-white focus:border-slate-950 focus:ring-0 outline-none transition-all resize-none"
                                />
                            </div>
                            <div className="pt-2">
                                <button
                                    type="submit"
                                    className="group w-auto  relative inline-flex items-center justify-center md:justify-between gap-3 md:px-5 px-3 py-2 border border-black/15 bg-white text-slate-900 font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-slate-950 hover:text-white hover:shadow-lg rounded-full"
                                >
                                    <span>Submit</span>
                                    <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1 group-hover:bg-white group-hover:text-slate-950">
                                        <Send size={15} />
                                    </div>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EventCTA
